<template>
    <div class="footer-full-page">
        <CompassButton v-bind="primaryAction" @click="primaryAction.action" />
        <CompassPlainButton
            v-for="(action, index) in secondaryActions"
            :key="index"
            variant="neutral"
            v-bind="action"
            @click="action.action"
        />
    </div>
</template>
<script>
export default {
    props: {
        primaryAction: {
            type: Object,
            required: true,
        },
        secondaryActions: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
<style lang="scss">
body:has(.footer-full-page) {
    padding-bottom: 80px;
}
</style>
<style lang="scss" scoped>
.footer-full-page {
    align-items: center;
    background: var(--colors-common-background-default);
    bottom: 0;
    box-shadow: var(--box-shadows-medium);
    display: flex;
    flex-direction: row-reverse;
    gap: var(--spacing-3);
    justify-content: end;
    left: 64px;
    min-height: 64px;
    padding: var(--spacing-4) var(--spacing-6);
    position: fixed;
    right: 0;
    z-index: 100;
}
</style>
